if (!customElements.get('mobile-dock')) {
  customElements.define(
    'mobile-dock',
    class MobileDock extends BaseElement {
      connectedCallback() {
        super.connectedCallback();
    
        if (Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get section() {
        return this._section = this._section || this.closest('.mobile-dock-section');
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        this.setAttribute('loaded', '');
    
        this.detectForHeader();
        this.detectForFooter();
        setTimeout(this.setHeight.bind(this));
        this.on(document, 'matchSmall', this.setHeight.bind(this));
    
        if (Shopify.designMode) {
          this.on(this.section, 'shopify:section:select', () => {
            this.section.classList.add('shopify-active');
          });
          this.on(this.section, 'shopify:section:deselect', () => {
            this.section.classList.remove('shopify-active');
          });
        }
      }
    
      detectForHeader() {
        const header = document.querySelector('.header-section');
        if (header === null) {
          this.section.classList.add('active');
          return;
        }
        
        if (!header.classList.contains('header-sticky')) {
          this.scrollY = parseInt(header.getBoundingClientRect().bottom + window.scrollY);
          const onScroll = theme.utils.throttle(this.onScrollForHeader.bind(this));
          this.on(window, 'scroll', onScroll, { passive: true });
          this.registerCleanup(() => onScroll.cancel());
        }
      }
    
      onScrollForHeader() {
        if (window.scrollY >= this.scrollY) {
          this.section.classList.add('active');
        }
        else {
          this.section.classList.remove('active');
        }
      }
    
      detectForFooter() {
        const footer = document.querySelector('.footer-copyright');
        if (footer === null) return;
    
        const onScroll = theme.utils.throttle(this.onScrollForFooter.bind(this));
        this.on(window, 'scroll', onScroll, { passive: true });
        this.registerCleanup(() => onScroll.cancel());
      }
    
      onScrollForFooter() {
        if (!theme.config.mqlSmall) return;
        
        const scrolledTo = window.scrollY + window.innerHeight;
        const threshold = this.offsetHeight;
        const isReachBottom = document.body.scrollHeight - threshold <= scrolledTo;
        this.classList.toggle('active', isReachBottom);
      }
    
      setHeight() {
        document.documentElement.style.setProperty('--mobile-dock-height', `${this.getBoundingClientRect().height.toFixed(1)}px`);
      }
    }, { extends: 'nav' }
  );
}

(function(){
  const safePosition=()=>{
    if(!window.matchMedia('(max-width: 749px)').matches)return;
    const dock=document.querySelector('nav.mobile-dock');
    const offset=Math.ceil((dock?.getBoundingClientRect().height||72)+16);
    const whatsapp=document.querySelector('gty-whatsapp-chat-button')?.shadowRoot?.querySelector('.gty-wacb-wrapper');
    if(whatsapp)whatsapp.style.setProperty('bottom',offset+'px','important');
    const agent=document.querySelector('shopify-chat')?.shadowRoot?.querySelector('[part="activator"]');
    if(agent)agent.style.setProperty('transform','translateY(-'+offset+'px)','important');
  };
  const observer=new MutationObserver(safePosition);
  observer.observe(document.documentElement,{childList:true,subtree:true});
  window.addEventListener('resize',safePosition,{passive:true});
  window.addEventListener('load',safePosition,{once:true});
  setTimeout(safePosition,500);
  setTimeout(safePosition,2000);
})();

(function(){
  let observedDrawer;
  let drawerObserver;

  const isCartOpen=drawer=>{
    if(!drawer)return false;
    return drawer.hasAttribute('open')
      || drawer.classList.contains('active')
      || drawer.getAttribute('aria-hidden')==='false'
      || window.getComputedStyle(drawer).pointerEvents!=='none';
  };

  const setWidgetVisibility=(element,hidden)=>{
    if(!element)return;
    if(hidden){
      element.style.setProperty('visibility','hidden','important');
      element.style.setProperty('pointer-events','none','important');
      element.style.setProperty('opacity','0','important');
    }else{
      element.style.removeProperty('visibility');
      element.style.removeProperty('pointer-events');
      element.style.removeProperty('opacity');
    }
  };

  const syncCartWidgets=()=>{
    const drawer=document.querySelector('cart-drawer#CartDrawer, cart-drawer');
    const hidden=isCartOpen(drawer);
    setWidgetVisibility(document.querySelector('gty-whatsapp-chat-button'),hidden);
    setWidgetVisibility(document.querySelector('shopify-chat'),hidden);
    setWidgetVisibility(document.querySelector('[data-bloom-assistant-nudge]'),hidden);

    if(drawer&&drawer!==observedDrawer){
      drawerObserver?.disconnect();
      observedDrawer=drawer;
      drawerObserver=new MutationObserver(syncCartWidgets);
      drawerObserver.observe(drawer,{attributes:true,attributeFilter:['open','class','aria-hidden','style']});
    }
  };

  const pageObserver=new MutationObserver(syncCartWidgets);
  pageObserver.observe(document.documentElement,{childList:true,subtree:true});
  window.addEventListener('load',syncCartWidgets,{once:true});
  document.addEventListener('cart:refresh',syncCartWidgets);
  setTimeout(syncCartWidgets,500);
  setTimeout(syncCartWidgets,2000);
})();
